// TabComponent.jsx
import React from 'react';
import PlateWell from "../../../components/platewells/PlateWell";
import PlateToolBar from '../../platewells/PlateToolBar';
import QlpConsumables from '../../platewells/InfoConsumables/QlpConsumables';
import "../../../components/platewells/PlateWell.css";
import QlpFileDownload from '../../platewells/fileDownloads/QlpFileDownload';

const InfoConsumable = () => {
    return (
        <>
            <div className="flex flex-grow min-h-screen  border-2 border-solid">
                <div className="flex flex-col w-full relative aspect[1] ">
                    <div className="flex p-5">
                        <PlateToolBar />
                        <QlpConsumables />
                        <QlpFileDownload />
                    </div>

                    <div className="flex-grow overflow-auto">
                        <PlateWell />
                    </div>

                </div>
                {/* <div className="w-1/4 ">
                    <div className='plate-control-panel'>
                        <PlateEdit />
                    </div>
                </div> */}


            </div >
            <div className="footer-area">

            </div>

        </>
    );
};

export default InfoConsumable;
